var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "toolbar" }, [
      _c("fieldset", { staticClass: "toolbar__filters" }, [
        _c(
          "div",
          { staticClass: "flex-fix" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filters.query,
                  expression: "filters.query",
                },
              ],
              attrs: { type: "hidden" },
              domProps: { value: _vm.filters.query },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filters, "query", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("FormControlSector", {
              attrs: {
                name: "sectors",
                multiple: true,
                "include-ancestors": false,
              },
              model: {
                value: _vm.filters.sectors,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "sectors", $$v)
                },
                expression: "filters.sectors",
              },
            }),
            _vm._v(" "),
            _c("FormControlDatepicker", {
              attrs: { name: "fromDate", label: "From date" },
              model: {
                value: _vm.filters.fromDate,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "fromDate", $$v)
                },
                expression: "filters.fromDate",
              },
            }),
            _vm._v(" "),
            _c("FormControlDatepicker", {
              attrs: { name: "toDate", label: "To date" },
              model: {
                value: _vm.filters.toDate,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "toDate", $$v)
                },
                expression: "filters.toDate",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.$wait.is("loading_search_sector_posts")
      ? _c(
          "div",
          { staticClass: "loading" },
          [_c("Spinner", { attrs: { height: 40, width: 40 } })],
          1
        )
      : _vm.items && _vm.items.length > 0
      ? _c(
          "div",
          { staticClass: "sector-post-feed" },
          [
            _vm._l(_vm.items, function (item) {
              return _c("SectorPostCard", {
                key: `sector-post-${item.id}`,
                attrs: {
                  resource: item,
                  "load-comments": false,
                  "sector-id": item.main_sector,
                  "show-read-more": false,
                  "show-actions": false,
                },
                on: {
                  "comment-click": function ($event) {
                    return _vm.handleNavigationToPost(item.main_sector, item.id)
                  },
                },
              })
            }),
            _vm._v(" "),
            _c("Pagination", {
              ref: "pagination",
              on: { "vuetable-pagination:change-page": _vm.onChangePage },
            }),
          ],
          2
        )
      : _c("div", { staticClass: "no-results" }, [_vm._v("No results")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }